import { render } from "./GamePage.vue?vue&type=template&id=0af97ec5"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Workplace\\WebFrameworks\\vuejs\\egg-picker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__